import toast from 'react-hot-toast';

import { CustomToast } from 'components/Toast/CustomToast';

export const useToast = () => {
  return (title, message, type = 'success', duration = 5000) => {
    toast.custom(t => <CustomToast t={t} title={title} message={message} type={type} />, {
      duration: duration,
    });
  };
};
